import React from 'react'
import { AreaDot } from '../../../../dynamic-power-prices/types'

interface Props {
  data: AreaDot
  color: string
}

/**
 *  This component creates a customized dot on the point with the current time
 * @param data is any type because rechart does not export the actual type for this internaly provided data
 * @param timeIndex
 * @param color
 */
const HoverDot: React.VFC<Props> = ({ data, color }) => {
  if (data?.payload?.isEmptyPoint) return null
  return (
    <svg x={data.cx - 6} y={data.cy - 6} width="12" height="12" viewBox="0 0 8 9" fill="none">
      <rect width="8" height="8" rx="4" transform="matrix(-1 0 0 1 7.99414 0.157898)" fill={color} />
      <rect width="6" height="6" rx="3" transform="matrix(-1 0 0 1 7 1)" fill="white" />
    </svg>
  )
}

export default HoverDot
